"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TILE_OPENING_TYPE = void 0;
var TILE_OPENING_TYPE = Object.freeze({
  TYPE_CASINO: 'bets',
  TYPE_SINGLE_ANSWER: 'votes'
});
exports.TILE_OPENING_TYPE = TILE_OPENING_TYPE;